/**
 * P3.3 — the investor's own-session "active journey" scope.
 *
 * <p>For a multi-journey (UC2) investor, the per-journey pages (onboarding documents, physical
 * submission) must know which product journey the investor is working within. Unlike the Service-Agent
 * side — where {@link ./saProxyAdapter} carries the journey and appends {@code selectedJourneyId} — the
 * investor's own session has no proxy, so we keep the selected journey here and the onboarding/physical
 * calls in {@code investor.service.ts} auto-append it as {@code journeyId}.</p>
 *
 * <p>Set when the investor opens/selects a journey (journey list, dashboard account selector, or a
 * deep-linked journey route). Empty = identity/default → the backend falls back to the primary journey,
 * so single-journey investors are unaffected. sessionStorage-backed so it survives in-app navigation
 * but not a new tab/session.</p>
 */
const KEY = 'facilon.activeInvestorJourney';

/** Set (or clear, with null) the journey the investor is currently working within. */
export const setActiveInvestorJourney = (journeyId: string | null): void => {
  try {
    if (journeyId) {
      sessionStorage.setItem(KEY, journeyId);
    } else {
      sessionStorage.removeItem(KEY);
    }
  } catch {
    /* sessionStorage unavailable (private mode / SSR) — journey scope simply falls back to primary */
  }
};

/** The investor's currently-selected journey (ss_investorproductid), or null when none is selected. */
export const getActiveInvestorJourney = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};
